import axios from 'axios';

export interface RuntimeConfig {
  TURNSTILE_SITE_KEY: string;
  UMAMI_WEBSITE_ID: string;
  UMAMI_URL: string;
}

let cachedConfig: RuntimeConfig | null = null;

export const loadRuntimeConfig = async (): Promise<RuntimeConfig> => {
  if (cachedConfig) {
    return cachedConfig;
  }

  try {
    const response = await axios.get('/config.json');
    cachedConfig = {
      TURNSTILE_SITE_KEY: response.data.TURNSTILE_SITE_KEY || '',
      UMAMI_WEBSITE_ID: response.data.UMAMI_WEBSITE_ID || '',
      UMAMI_URL: response.data.UMAMI_URL || '',
    };
    return cachedConfig;
  } catch (error) {
    console.warn('Failed to load config.json, falling back to environment variables', error);
  }

  cachedConfig = {
    TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',
    UMAMI_WEBSITE_ID: process.env.REACT_APP_UMAMI_WEBSITE_ID || '',
    UMAMI_URL: process.env.REACT_APP_UMAMI_URL || '',
  };
  return cachedConfig;
};

export const getRuntimeConfig = (): RuntimeConfig => {
  if (!cachedConfig) {
    throw new Error('Runtime config not loaded. Call loadRuntimeConfig() first.');
  }
  return cachedConfig;
};

